export const CACHE_TIME = {
  USER_PROFILE: 15 * 60 * 1000,
  MASTER_DATA: Infinity,
  SHORT: 5 * 60 * 1000,
} as const;